var _defs, _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBundleRibbon = function SvgBundleRibbon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 392 284",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bundle-ribbon-1{fill:url(#linear-gradient);}.bundle-ribbon-2{fill:url(#linear-gradient-2);}.bundle-ribbon-3{fill:url(#linear-gradient-3);}.bundle-ribbon-4{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.78,
    y1: 280.14,
    x2: 28.65,
    y2: 279.9,
    gradientTransform: "matrix(1, 0, 0, -1, 119, 350)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f11e37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10015"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 141.34,
    y1: 140.79,
    x2: 159.71,
    y2: 140.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 17.85,
    y1: 346.33,
    x2: 162.71,
    y2: 90.1,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bundle-ribbon-1",
    d: "M117.3,60.67,117.15,79l30.43.25.15-18.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bundle-ribbon-2",
    d: "M260.47,194l-.25,30.43,18.36.15.25-30.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "bundle-ribbon-3",
    d: "M117.3,60.67l161.27,163.9,0,0,.47-57.72a11.79,11.79,0,0,0-3.4-8.39L183.4,64.67a11.79,11.79,0,0,0-8.34-3.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "bundle-ribbon-4",
    d: "M184.67,105.51a5.29,5.29,0,0,1-3,1.6,5.48,5.48,0,0,1-3.14-.58,11.37,11.37,0,0,1-3.15-2.36l-4.92-5,14.18-13.89L189.33,90a9.76,9.76,0,0,1,2,2.87,5,5,0,0,1,.48,2.83,4.39,4.39,0,0,1-1.39,2.59,4.07,4.07,0,0,1-2.36,1.2,5.13,5.13,0,0,1-2.65-.43,6.48,6.48,0,0,1,.77,3.34A4.5,4.5,0,0,1,184.67,105.51ZM186.76,92l-1.53-1.56-3.36,3.29,1.53,1.56a3.18,3.18,0,0,0,1.91,1.06,2.16,2.16,0,0,0,1.79-.68,2,2,0,0,0,.68-1.74A3.22,3.22,0,0,0,186.76,92Zm-11.09,7.8,1.82,1.87a4.42,4.42,0,0,0,2.3,1.33,2.56,2.56,0,0,0,2.31-.84,2.33,2.33,0,0,0,.79-2.2,4.61,4.61,0,0,0-1.3-2.3l-1.83-1.86ZM197.13,98l2.83,2.9L190.6,110a4,4,0,0,0-1.29,2.53,3.36,3.36,0,0,0,1.12,2.6,3.27,3.27,0,0,0,2.57,1.17,4,4,0,0,0,2.56-1.24l9.36-9.17,2.86,2.92-9.52,9.33a7.45,7.45,0,0,1-3.51,2,6.32,6.32,0,0,1-3.65-.24,9.71,9.71,0,0,1-5.48-5.59,6.36,6.36,0,0,1-.14-3.64,7.39,7.39,0,0,1,2.12-3.46Zm23.41,23.9,2.76,2.82-14.9,14.59L208,120l-8.75,8.57-2.78-2.83,14.89-14.59.41,19.34Zm-3.7,24.6-4.73-4.82,14.19-13.9,4.72,4.83a11.55,11.55,0,0,1,3,4.76,8.83,8.83,0,0,1,.09,5,11.23,11.23,0,0,1-7.5,7.34,8.89,8.89,0,0,1-5-.19A11.56,11.56,0,0,1,216.84,146.46Zm11.45-11.38-1.71-1.74L217.7,142l1.71,1.75a7.69,7.69,0,0,0,2.67,1.83,5.12,5.12,0,0,0,3,.23,6.56,6.56,0,0,0,3.16-1.87,6.44,6.44,0,0,0,1.92-3.11,4.89,4.89,0,0,0-.17-3.05A7.52,7.52,0,0,0,228.29,135.08Zm12.23,7.19,2.86,2.92-11.63,11.39,5.54,5.65-2.56,2.5-8.39-8.57Zm10,10.21,8.86,9-2.48,2.42-6.07-6.2-3,2.92,5.68,5.79-2.41,2.36L245.44,163l-3.85,3.77,6.07,6.2-2.47,2.42-8.85-9Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBundleRibbon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bundleRibbon.10f2a486.svg";
export { ForwardRef as ReactComponent };